export class DajSveInterneSifarnike {
    static type = '[Sifarnici] DajSveSifarnikeZaRecnikPojmova';
}